import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Group, Image, Rect } from 'react-konva';
import Konva from 'konva';
import colorString from 'color-string';
import EndCap from './endcap';
import {
  activate,
  activateByArray,
  deactivate,
  deactivateByArray,
  getChamberAccessoryMap,
  modifyChambersByArray,
  modifyChambersByManifoldVoidArray,
  resetSelectedChamber,
  selectChamberContext,
  setFeedConnectorValues,
  setInsertaTeeValues,
  setInsertaTeeWarningType,
  setSelectedChamber,
  showInsertaTeeWarning,
} from '../../actions/chamber-actions';
import {
  CHAMBER_ACCESSORY_ID_INSERTA_TEE,
  CHAMBER_ACCESSORY_ID_INSPECTION_PORT,
  ENDCAP_POSITION_LOWER,
  ENDCAP_POSITION_UPPER,
  GLOBAL_DRAWING_MODE_ADD,
  GLOBAL_DRAWING_MODE_INLET_MANIFOLD,
  GLOBAL_DRAWING_MODE_INSERTA_TEE,
  GLOBAL_DRAWING_MODE_INSPECTION_PORT,
  GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD,
  GLOBAL_DRAWING_MODE_REMOVE,
  GLOBAL_DRAWING_SELECTOR_MODE_DIRECT,
  INLET_MANIFOLD_ID,
  MSG_INVALID_DRAWING_MODE_ERROR,
  OUTLET_MANIFOLD_ID,
} from '../../lib/types';
import {
  setChamberAccesory,
  setChamberLowerCapAccesory,
  setChamberUpperCapAccesory,
} from '../../actions/floating-tool-actions';
import {
  setOverlapPresent,
  showManifoldEntryDialog,
  toggleOverlapDialog,
  showManifoldChamberEditOrRemove,
} from '../../actions/manifold-entry-actions';
import { getScaledValue } from '../../actions/calculations-actions';
import { modalAlertActions } from '../../actions/modal-alert.actions';
import { getRequiredChamberSlotsForTwoEndcaps } from '../../lib/chamberBed/utils';
import { endCapsAutoAdd } from '../../actions/drawingtoolbar-actions';
import { updateCurrentSelectedChamber } from '../../actions/current-selected-chamber-actions';
import ManifoldService from '../../lib/services/manifold-service';
import IsolatorService from '../../lib/services/isolator_service';
import { createMainManifold } from '../../actions/manifold-actions';
import ChamberService from '../../lib/services/chambers-service';
import { setDirtyStateForMultiBeds } from '../../actions/multi-bed-actions';
import {
  floatingToolInsertaTeeClose,
  floatingToolInsertaTeeOpen,
} from '../../actions/floating-tool-inserta-tee-actions';
import ManifoldSelectors from '../../reducers/main-manifold-reducer';
import {
  floatingToolInsertaInspectionClose,
  floatingToolInsertaInspectionOpen,
  floatingToolInspectionClose,
  floatingToolInspectionOpen,
} from '../../actions/floating-tool-inspection-port-actions';
import { shouldChamberPlaceFeedConnector } from '../../lib/misc/misc_utils';

const debugChambersENV = false;
// loading the chamber drawing image
const chamberImgURL = require('../../media/chamber.png');
const chamberImg = new window.Image();
chamberImg.src = chamberImgURL;
const chamberImgIsolatorURL = require('../../media/chamber-isolator.png');
const chamberImgIsolator = new window.Image();
chamberImgIsolator.src = chamberImgIsolatorURL;

class Chamber extends PureComponent {
  state = {
    currentChamberAccessoryId: null,
    showChangeChamberAccessoryModal: false,
    addFeedConnectorArray: [],
  };

  setAccessoryColoring(chamberNode) {
    if (
      this.props.active &&
      this.props.accessory &&
      this.props.accessory.id &&
      this.props.accessory.id !== 'none' &&
      chamberNode
    ) {
      /* cache the image */
      //chamberNode.cache();
      /* get rgb array from accessory color */
      let rgb = colorString.get.rgb(this.props.accessory.color);
      /* set the green red and blue of the image */
      chamberNode.red(rgb[0]);
      chamberNode.green(rgb[1]);
      chamberNode.blue(rgb[2]);
    } else if (this.props.active && chamberNode) {
      //chamberNode.clearCache();
    }
  }

  handleOnMouseEnter() {
    let opacityValue = this.props.enableTransparency ? 0.8 : 0.5;

    if (this.props.active) {
      this.chamberNode.opacity(opacityValue);
    } else if (this.props.drawingMode === GLOBAL_DRAWING_MODE_ADD) {
      this.chamberNode.fill('#0C92CD');
    }
    this.chamberNode.getLayer().batchDraw();
  }

  handleOnMouseLeave() {
    let opacityValue = this.props.enableTransparency ? 0.5 : 0.8;

    if (this.props.active && !this.chamberIsSelected()) {
      this.chamberNode.opacity(opacityValue);
    } else {
      this.chamberNode.fill('transparent');
    }
    this.chamberNode.getLayer().batchDraw();
  }

  updateCurrentChamber() {
    return this.props.updateCurrentSelectedChamber({
      row: this.props.row,
      col: this.props.col,
      chamberbed: this.props.chamberbed,
    });
  }

  handleOnChamberClick(evt) {
    let wasRightClick = evt.which === 3;
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        /*if (this.props.active && wasRightClick) {
          this.props.setSelectedChamber(this.props.row, this.props.col);
        } else if (
          this.props.active &&
          !wasRightClick &&
          this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT
        ) {
          if (ChamberService.isChamberMetaInUse(this.props.row, this.props.col, "isVoidArray")) return false;
          this.props.activate(this.props.row, this.props.col);
          this.props.resetSelectedChamber();
          this.props.selectChamberContext(this.props.row, this.props.col);
        } else if (!this.props.active && !wasRightClick) {

          // Makes sure if chamber void is being used by a manifold
          if (ChamberService.isChamberMetaInUse(this.props.row, this.props.col, "isVoidArray")) return false;

          this.props.activate(this.props.row, this.props.col);

          this.props.resetSelectedChamber();
        } else if (this.props.active) {
          this.props.resetSelectedChamber();
        }
        this.updateCurrentChamber();*/
        break;

      case GLOBAL_DRAWING_MODE_REMOVE: {
        /*let activeManifoldId;
        let accessory;
        if (this.props.lowerCapAccessory && this.props.lowerCapAccessory.manifoldId) {
          activeManifoldId = this.props.lowerCapAccessory.manifoldId;
          accessory = this.props.lowerCapAccessory;
        } else if (this.props.upperCapAccessory && this.props.upperCapAccessory.manifoldId) {
          activeManifoldId = this.props.upperCapAccessory.manifoldId;
          accessory = this.props.upperCapAccessory;
        }

        if (this.props.active && wasRightClick) {
          this.props.setSelectedChamber(this.props.row, this.props.col);
        } else if (this.props.active && !wasRightClick) {
          if (activeManifoldId) {
            this.props.showManifoldChamberEditOrRemove(true, this.props.row, this.props.col, activeManifoldId, accessory);
          } else {
            if (ChamberService.isChamberMetaInUse(this.props.row, this.props.col, "isManifoldConnectedArray")) return false;
            this.props.deactivate(this.props.row, this.props.col);
          }
          this.props.resetSelectedChamber();
        } else if (!this.props.active) {
          this.props.resetSelectedChamber();
        }
        this.updateCurrentChamber();*/
        break;
      }

      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
        this.updateCurrentChamber();
        return this.handleChamberAccessory(CHAMBER_ACCESSORY_ID_INSERTA_TEE);

      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
        return this.handleChamberAccessory(CHAMBER_ACCESSORY_ID_INSPECTION_PORT);

      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD: {
        let activeManifoldId, capAccessory;

        if (this.props.lowerCapAccessory && this.props.lowerCapAccessory.manifoldId) {
          activeManifoldId = this.props.lowerCapAccessory.manifoldId;
          capAccessory = this.props.lowerCapAccessory;
        } else if (this.props.upperCapAccessory && this.props.upperCapAccessory.manifoldId) {
          activeManifoldId = this.props.upperCapAccessory.manifoldId;
          capAccessory = this.props.upperCapAccessory;
        }

        if (activeManifoldId) {
          this.props.showManifoldEntryDialog(activeManifoldId, capAccessory, true);
          this.updateCurrentChamber();
          return false;
        } else {
          this.updateCurrentChamber();
          return ManifoldService.handleManifoldBuildRestrictions(INLET_MANIFOLD_ID, this.props);
        }
      }

      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD: {
        let activeManifoldId, capAccessory;
        if (this.props.lowerCapAccessory && this.props.lowerCapAccessory.manifoldId) {
          activeManifoldId = this.props.lowerCapAccessory.manifoldId;
          capAccessory = this.props.lowerCapAccessory;
        } else if (this.props.upperCapAccessory && this.props.upperCapAccessory.manifoldId) {
          activeManifoldId = this.props.upperCapAccessory.manifoldId;
          capAccessory = this.props.upperCapAccessory;
        }
        if (activeManifoldId) {
          this.props.showManifoldEntryDialog(activeManifoldId, capAccessory, true);
          this.updateCurrentChamber();
          return false;
        } else {
          this.updateCurrentChamber();
          return ManifoldService.handleManifoldBuildRestrictions(OUTLET_MANIFOLD_ID, this.props);
        }
      }

      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  }

  handleChamberAccessory(id) {
    if (this.ignoreAccessoryAttachment(id)) {
      return;
    }

    if (this.props.active) {
      let chamberAccessory = this.getChamberAccessory(id);

      if (this.hasOtherChamberAccessory(id)) {
        return this.setState({
          currentChamberAccessoryId: null,
          showChangeChamberAccessoryModal: true,
        });
      }

      // Check if chamber is part of an isolator and show warning for insta tee
      const chamberContainsIsolator =
        this.props.chamberRows[this.props.row]._chambers[this.props.col].isIsolatorArray.length > 0;
      const chamberContainsTee =
        this.props.chamberRows[this.props.row]._chambers[this.props.col]._accessory &&
        this.props.chamberRows[this.props.row]._chambers[this.props.col]._accessory.id === 'Inserta-tee';
      if (chamberContainsIsolator) {
        if (!chamberContainsTee && id === 'Inserta-tee') {
          this.props.showInsertaTeeWarning(true);
          this.props.setInsertaTeeValues(this.props.row, this.props.col, chamberAccessory);
        } else {
          if (id === 'Inserta-tee') {
            if (this.props.isTeeDialogOpen || this.props.isInspectionPortDialogOpen) {
              this.props.floatingToolInsertaTeeClose();
              this.props.floatingToolInspectionClose();
            }
            chamberAccessory = this.getChamberAccessoryTee(id);
            this.props.floatingToolInsertaTeeOpen(this.props.row, this.props.col, chamberAccessory);
          } else {
            if (id === 'Inspection-port') {
              if (this.props.isTeeDialogOpen || this.props.isInspectionPortDialogOpen) {
                this.props.floatingToolInsertaTeeClose();
                this.props.floatingToolInspectionClose();
              }
              chamberAccessory = this.getChamberAccessoryTee(id);
              this.props.floatingToolInspectionOpen(this.props.row, this.props.col, chamberAccessory);
            } else {
              this.props.setChamberAccesory(this.props.row, this.props.col, chamberAccessory);
            }
          }
        }
      } else {
        if (this.props.isTeeDialogOpen || this.props.isInspectionPortDialogOpen) {
          this.props.floatingToolInsertaTeeClose();
          this.props.floatingToolInspectionClose();
        }

        if (id === 'Inserta-tee') {
          chamberAccessory = this.getChamberAccessoryTee(id);
          this.props.floatingToolInsertaTeeOpen(this.props.row, this.props.col, chamberAccessory);
        } else {
          if (id === 'Inspection-port') {
            chamberAccessory = this.getChamberAccessoryTee(id);
            this.props.floatingToolInspectionOpen(this.props.row, this.props.col, chamberAccessory);
          } else {
            this.props.setChamberAccesory(this.props.row, this.props.col, chamberAccessory);
          }
        }
      }
    }
  }

  hasOtherChamberAccessory(id) {
    return this.props.accessory && this.props.accessory.id !== undefined && this.props.accessory.id !== id;
  }

  getChamberAccessory(id) {
    if (!this.props.accessory || this.props.accessory.id !== id) {
      return this.props.getChamberAccessoryMap().get(id);
    }

    return null;
  }

  getChamberAccessoryTee(id) {
    return this.props.getChamberAccessoryMap().get(id);
  }

  getChamberAccessoryInspection(id) {
    return this.props.getChamberAccessoryMap().get(id);
  }

  ignoreAccessoryAttachment(id) {
    try {
      const accessory = this.props.getChamberAccessoryMap().get(id);
      const exception = accessory.exceptions[this.props.chamberType.id];

      if (exception && !exception.attachable) {
        return true;
      }
    } catch (exception) {
      console.warn("An issue occurred checking the accessory's exceptions", exception);
    }
    return false;
  }

  chamberIsSelected() {
    return this.props.row === this.props.selectedChamberRow && this.props.col === this.props.selectedChamberCol;
  }

  renderChamberElement() {
    // debug chambers - Use to debug chamber placed Metadata - use for debug
    const debug = debugChambersENV;
    const renderAccessories = () => {
      const { accessory, width: chamberWidth, height: chamberHeight, row, chamberRows, col } = this.props;
      let strokeWidth = this.props.getScaledValue(0.3);
      let fill = '#d3d3d3';
      let stroke = 'black';
      if (accessory && accessory.id) {
        let firstActiveChamberRow = chamberRows.find((chamberRow) => chamberRow.getActiveCount());
        let lastActiveChamberRow = chamberRows
          .slice()
          .reverse()
          .find((chamberRow) => chamberRow.getActiveCount());

        firstActiveChamberRow = firstActiveChamberRow ? firstActiveChamberRow.row : 0;
        lastActiveChamberRow = lastActiveChamberRow ? lastActiveChamberRow.row : 0;

        const activeChamberRowAverage = (firstActiveChamberRow + lastActiveChamberRow) / 2;

        /* InsertaTee Component isTeeDialogOpen */
        if (accessory.id === 'Inserta-tee') {
          const width = this.props.getScaledValue(3 / 12);
          const height = this.props.getScaledValue(20 / 12);
          const showHighlight =
            this.props.isTeeActiveCoordinates.row !== null &&
            this.props.isTeeActiveCoordinates.col !== null &&
            this.props.isTeeActiveCoordinates.col === col &&
            this.props.isTeeActiveCoordinates.row === row;

          if (row <= activeChamberRowAverage) {
            // Shows Tee for the opposite side
            return (
              <React.Fragment>
                {this.props.isTeeDialogOpen && (
                  <Rect
                    fill={'rgba(255,152,0,0.8)'}
                    width={width + 10}
                    height={height + 2}
                    visible={showHighlight}
                    x={(chamberWidth - width - 10) / 2}
                    y={-height - 1}
                  />
                )}
                <Rect
                  x={(chamberWidth - width) / 2}
                  y={-height}
                  fill={fill}
                  stroke={stroke}
                  strokeWidth={strokeWidth}
                  height={height}
                  width={width}
                />
              </React.Fragment>
            );
          }

          return (
            <React.Fragment>
              {this.props.isTeeDialogOpen && (
                <Rect
                  fill={'rgba(255,152,0,0.8)'}
                  width={width + 10}
                  height={height + 2}
                  visible={showHighlight}
                  x={(chamberWidth - width - 10) / 2}
                  y={chamberHeight + 0}
                />
              )}
              <Rect
                x={(chamberWidth - width) / 2}
                y={chamberHeight}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                height={height}
                width={width}
              />
            </React.Fragment>
          );
        } else if (accessory.id === 'Inspection-port') {
          // Inspection Port highlighting
          const length = this.props.getScaledValue(14 / 12);
          const showHighlightInspection =
            this.props.isInspectionPortActiveCoordinates.row !== null &&
            this.props.isInspectionPortActiveCoordinates.col !== null &&
            this.props.isInspectionPortActiveCoordinates.col === col &&
            this.props.isInspectionPortActiveCoordinates.row === row;
          return (
            <React.Fragment>
              {this.props.isInspectionPortDialogOpen && (
                <Rect
                  x={(chamberWidth + 5 - length) / 2}
                  y={(chamberHeight + 5 - length) / 2}
                  fill={'rgb(255,0,0)'}
                  stroke={'rgb(255,0,0)'}
                  width={length}
                  height={length}
                  visible={showHighlightInspection}
                />
              )}
              <Rect
                x={(chamberWidth - length) / 2}
                y={(chamberHeight - length) / 2}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                height={length}
                width={length}
              />
            </React.Fragment>
          );
        }
      } else if (
        debug &&
        (this.props.isManifoldConnectedArray.length > 0 ||
          this.props.isVoidArray.length > 0 ||
          this.props.isOppositeStubAttached)
      ) {
        const length = this.props.getScaledValue(14 / 12);
        if (debug && (this.props.isManifoldConnectedArray.length > 0 || this.props.isVoidArray.length > 0)) {
          strokeWidth = 2;
          fill = 'red';
          stroke = 'green';
        }
        if (debug && this.props.isOppositeStubAttached === true) {
          strokeWidth = 1;
          fill = 'white';
          stroke = 'blue';
        }
        if (debug && (this.props.upperCapAccessory || this.props.lowerCapAccessory)) {
          strokeWidth = 5;
          fill = 'green';
          stroke = 'blue';
        }
        return (
          <Rect
            x={(chamberWidth - length) / 2}
            y={(chamberHeight - length) / 2}
            fill={fill}
            stroke={stroke}
            strokeWidth={strokeWidth}
            height={length}
            width={length}
          />
        );
      }
      return null;
    };

    const renderFeedConnector = () => {
      let { accessory, width: chamberWidth, height: chamberHeight, chamberType } = this.props;
      let strokeWidth = this.props.getScaledValue(0.3);
      let fill = 'black';
      let stroke = 'black';
      const width = this.props.getScaledValue(3 / 12);
      const height = this.props.getScaledValue(20 / 12);

      const chamberHeightPos = () => {
        switch (chamberType.id) {
          case 'R-280HD':
            return this.props.getScaledValue((height * 0.5) / width);
          case 'R-330XLHD':
            return this.props.getScaledValue((height * 0.55) / width);
          case 'R-300HD':
            return this.props.getScaledValue((height * 0.55) / width);
          case 'R-360HD':
            return this.props.getScaledValue((height * 0.7) / width);
          case 'R-902HD':
            return this.props.getScaledValue((height * 0.9) / width);
          default:
            return this.props.getScaledValue((height * 0.35) / width);
        }
      };

      if (accessory && accessory.id) {
        if (accessory.id === 'Feed-connector') {
          return (
            <React.Fragment>
              <Rect
                x={(chamberWidth - width) / 2}
                y={chamberHeightPos()}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                height={height}
                width={width}
              />
            </React.Fragment>
          );
        }
      }
      return null;
    };

    let opacityValueSelected = this.props.enableTransparency ? 0.8 : 0.5;
    let opacityValueDeselected = this.props.enableTransparency ? 0.5 : 0.8;
    let opacityValue = this.chamberIsSelected() ? opacityValueSelected : opacityValueDeselected;

    if (this.props.active) {
      return (
        <React.Fragment>
          {renderFeedConnector()}
          <Group>
            <Image
              id={`${this.props.row}-${this.props.col}`}
              name="chamber"
              perfectDrawEnabled={false}
              image={
                IsolatorService.hasIsolator(this.props.chamberRows, this.props.col, this.props.row)
                  ? chamberImgIsolator
                  : chamberImg
              }
              height={this.props.height}
              width={this.props.width}
              stroke={this.props.enableDebuging ? 'red' : 'black'}
              strokeWidth={this.props.enableDebuging ? 2 : 1}
              opacity={opacityValue}
              ref={(node) => {
                this.chamberNode = node;
                this.setAccessoryColoring(node);
              }}
              filters={[Konva.Filters.RGB]}
            />
          </Group>
          {renderAccessories()}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Rect
            height={this.props.height}
            width={this.props.width}
            stroke={'gray'}
            strokeWidth={0.5}
            dash={[3, 3]}
            ref={(node) => {
              this.chamberNode = node;
              this.setAccessoryColoring(node);
            }}
          />
          {debug && renderAccessories()}
          {renderFeedConnector()}
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <Group
          height={this.props.height}
          width={this.props.width}
          x={this.props.x}
          y={this.props.y}
          onMouseEnter={() => this.handleOnMouseEnter()}
          onMouseLeave={() => this.handleOnMouseLeave()}
          onClick={({ evt }) => this.handleOnChamberClick(evt)}
          ref={(node) => {
            this.groupNode = node;
          }}>
          {/* Render the element depending if active or not */}
          {this.renderChamberElement()}
          <EndCap
            row={this.props.row}
            col={this.props.col}
            x={-this.props.endCapWidth}
            y={0}
            installedOffSet={this.props.endCapInstalledOffset}
            active={this.props.upperCapActive}
            height={this.props.endCapHeight}
            width={this.props.endCapWidth}
            chamberHeight={this.props.height}
            chamberWidth={this.props.width}
            isIsolator={IsolatorService.hasIsolator(this.props.chamberRows, this.props.col, this.props.row)}
            accessory={this.props.upperCapAccessory}
            position={ENDCAP_POSITION_UPPER}
            rotation={0}
            chamberType={this.props.chamberType}
            ref={(node) => {
              this.upperEndcapNode = node;
            }}
          />
          <EndCap
            row={this.props.row}
            col={this.props.col}
            x={this.props.width + this.props.endCapWidth - this.props.chamberInstalledOffset}
            y={this.props.height}
            installedOffSet={-this.props.endCapInstalledOffset}
            active={this.props.lowerCapActive}
            height={this.props.endCapHeight}
            width={this.props.endCapWidth}
            chamberHeight={this.props.height}
            chamberWidth={this.props.width}
            isIsolator={IsolatorService.hasIsolator(this.props.chamberRows, this.props.col, this.props.row)}
            accessory={this.props.lowerCapAccessory}
            position={ENDCAP_POSITION_LOWER}
            rotation={180}
            chamberType={this.props.chamberType}
            ref={(node) => {
              this.lowerEndcapNode = node;
            }}
          />
        </Group>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chamberRows: state.chamberbed.chamberRows,
    chamberType: state.globals.chamberType,
    chamberEndCapType: state.globals.chamberEndCapType,
    content: state.localization.content,
    drawingMode: state.globals.drawingMode,
    drawingSelectorMode: state.globals.drawingSelectorMode,
    lang: state.localization.lang,
    selectedChamberCol: state.chamberbed.selectedChamberCol,
    selectedChamberRow: state.chamberbed.selectedChamberRow,
    totalStorageProvided: state.calculations.totalStorageProvided,

    chamberbed: state.chamberbed,
    scaleX: state.chamberbed.scaleX,
    scaleY: state.chamberbed.scaleY,
    scalePixels: state.globals.scalePixels,
    scaleValue: state.globals.scaleValue,

    mainManifolds: state.mainManifolds,

    enableDebuging: state.globals.enableDebuging,
    enableTransparency: state.globals.enableTransparency,
    pressedKeys: state.globals.pressedKeys,
    isTeeDialogOpen: state.floatingToolInsertaTee.openDialog,
    isTeeActiveCoordinates: {
      col: state.floatingToolInsertaTee.col,
      row: state.floatingToolInsertaTee.row,
    },

    isInspectionPortDialogOpen: state.floatingToolInspectionPort.openDialog,
    isInspectionPortActiveCoordinates: {
      col: state.floatingToolInspectionPort.col,
      row: state.floatingToolInspectionPort.row,
    },

    hasImperviousLiner: state.calculations.hasImperviousLiner,
  };
};

const mapDispatchToProps = {
  activate,
  activateByArray,
  deactivate,
  deactivateByArray,

  modifyChambersByArray,

  getChamberAccessoryMap,
  getScaledValue,
  modalAlertActions,
  resetSelectedChamber,
  selectChamberContext,
  setChamberAccesory,
  setChamberLowerCapAccesory,
  setChamberUpperCapAccesory,

  createMainManifold,
  modifyChambersByManifoldVoidArray,

  setSelectedChamber,
  showManifoldEntryDialog,
  getRequiredChamberSlotsForTwoEndcaps,
  endCapsAutoAdd,
  updateCurrentSelectedChamber,

  toggleOverlapDialog,
  setOverlapPresent,

  showManifoldChamberEditOrRemove,
  setDirtyStateForMultiBeds,
  showInsertaTeeWarning,
  setInsertaTeeValues,
  setInsertaTeeWarningType,

  floatingToolInsertaTeeOpen,
  floatingToolInsertaTeeClose,

  floatingToolInspectionOpen,
  floatingToolInspectionClose,

  setFeedConnectorValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(Chamber);



// WEBPACK FOOTER //
// ./src/components/Drawings/chamber.js